import type { ITemplateConfiguration } from '@/domain/template/ITemplateConfiguration';

function getBackgroundColorForSide(configuration: ITemplateConfiguration, side: 'recto' | 'verso'): string {
    if (side === 'verso') {
        return configuration.backgroundColorVerso ?? 'transparent';
    }
    return configuration.backgroundColor ?? 'transparent';
}

export { getBackgroundColorForSide };
